export default {"src":"/_next/static/media/send.277ad29a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};